/**
 * The comment box's emoji set (Messaging Drop 3b).
 *
 * A fixed list rather than a picker library: Kyu's rule for 3b was no new npm
 * dependency, and a comment needs the common faces and hands, not all 3,700
 * code points. The quick reactions in 3b-2 reuse this same list, so a
 * reaction and a typed emoji always look the same.
 *
 * Each entry is plain text. Inserting one puts a text character into the
 * document, never markup, so it adds nothing for the sanitizer to judge.
 */
export interface CommentEmoji {
  char: string;
  /** Read out by screen readers and shown on hover. */
  name: string;
}

export const COMMENT_EMOJI: readonly CommentEmoji[] = [
  { char: '👍', name: 'thumbs up' },
  { char: '👎', name: 'thumbs down' },
  { char: '👏', name: 'clapping' },
  { char: '🙌', name: 'raised hands' },
  { char: '🙏', name: 'thank you' },
  { char: '👌', name: 'ok hand' },
  { char: '✌️', name: 'victory hand' },
  { char: '🤝', name: 'handshake' },
  { char: '💪', name: 'strong' },
  { char: '👋', name: 'waving hand' },
  { char: '👀', name: 'eyes' },
  { char: '🫡', name: 'salute' },
  { char: '😀', name: 'grinning' },
  { char: '😃', name: 'big smile' },
  { char: '😄', name: 'smiling eyes' },
  { char: '😁', name: 'beaming' },
  { char: '😆', name: 'laughing' },
  { char: '😅', name: 'sweat smile' },
  { char: '😂', name: 'tears of joy' },
  { char: '🤣', name: 'rolling on the floor laughing' },
  { char: '🙂', name: 'slight smile' },
  { char: '😉', name: 'winking' },
  { char: '😊', name: 'blushing smile' },
  { char: '😇', name: 'halo' },
  { char: '🥰', name: 'smiling with hearts' },
  { char: '😍', name: 'heart eyes' },
  { char: '🤩', name: 'star struck' },
  { char: '😘', name: 'blowing a kiss' },
  { char: '😋', name: 'yum' },
  { char: '😎', name: 'sunglasses' },
  { char: '🤓', name: 'nerd' },
  { char: '🤗', name: 'hug' },
  { char: '🤔', name: 'thinking' },
  { char: '🤨', name: 'raised eyebrow' },
  { char: '😐', name: 'neutral' },
  { char: '😑', name: 'expressionless' },
  { char: '🙄', name: 'eye roll' },
  { char: '😏', name: 'smirk' },
  { char: '😬', name: 'grimace' },
  { char: '😌', name: 'relieved' },
  { char: '😴', name: 'sleeping' },
  { char: '🤯', name: 'mind blown' },
  { char: '😮', name: 'surprised' },
  { char: '😲', name: 'astonished' },
  { char: '🥹', name: 'holding back tears' },
  { char: '😢', name: 'crying' },
  { char: '😭', name: 'sobbing' },
  { char: '😤', name: 'huffing' },
  { char: '😡', name: 'angry' },
  { char: '😱', name: 'screaming' },
  { char: '🥳', name: 'party face' },
  { char: '🤞', name: 'fingers crossed' },
  { char: '🤷', name: 'shrug' },
  { char: '🤦', name: 'facepalm' },
  { char: '🙈', name: 'see no evil' },
  { char: '💀', name: 'skull' },
  { char: '❤️', name: 'red heart' },
  { char: '💙', name: 'blue heart' },
  { char: '💚', name: 'green heart' },
  { char: '💛', name: 'yellow heart' },
  { char: '💜', name: 'purple heart' },
  { char: '🖤', name: 'black heart' },
  { char: '💯', name: 'hundred' },
  { char: '🔥', name: 'fire' },
  { char: '✨', name: 'sparkles' },
  { char: '⭐', name: 'star' },
  { char: '🎉', name: 'party popper' },
  { char: '🎊', name: 'confetti' },
  { char: '🎁', name: 'gift' },
  { char: '🏆', name: 'trophy' },
  { char: '🥇', name: 'first place' },
  { char: '🚀', name: 'rocket' },
  { char: '✅', name: 'check mark' },
  { char: '☑️', name: 'ticked box' },
  { char: '❌', name: 'cross mark' },
  { char: '⚠️', name: 'warning' },
  { char: '❗', name: 'exclamation' },
  { char: '❓', name: 'question' },
  { char: '💡', name: 'idea' },
  { char: '📌', name: 'pin' },
  { char: '📎', name: 'paperclip' },
  { char: '📝', name: 'memo' },
  { char: '📅', name: 'calendar' },
  { char: '⏰', name: 'alarm clock' },
  { char: '⏳', name: 'hourglass' },
  { char: '📈', name: 'chart up' },
  { char: '📉', name: 'chart down' },
  { char: '💰', name: 'money bag' },
  { char: '📦', name: 'package' },
  { char: '🚚', name: 'delivery truck' },
  { char: '📣', name: 'megaphone' },
  { char: '☕', name: 'coffee' },
  { char: '🌊', name: 'wave' },
  { char: '🐢', name: 'turtle' },
  { char: '🐳', name: 'whale' },
  { char: '♻️', name: 'recycle' },
];
